export default {
  methods: {
    resetModel(ref) {
      let model = ref && ref.model && Object.entries(ref.model).length ? ref.model : {}
      
      if (model && typeof model == 'object' && Object.entries(model).length) {
        for (let key in model) {
          if (typeof model[key] == 'string')
            model[key] = ''
          else if (typeof model[key] == 'number')
            model[key] == 0
          else if (Array.isArray(model[key]))
            model[key] = []
          else if (typeof model[key] == 'object' && !Array.isArray(model[key]))
            model[key] = {}
        }
      }
    },
    reload(ref) {
      if (ref && ref.fetchData && typeof ref.fetchData == 'function') {
        ref.fetchData()
      }
      if (ref && ref.removeImage && typeof ref.removeImage == 'function') {
        ref.removeImage()
      }
      if (ref && ref.currentTab && ref.currentTab != 0) {
        ref.currentTab = 0
      }
    }
  }
}
